// MUST stay in sync with the corresponding file in backend/. When adding,
// removing, or reordering sections, update both.
//
// Display order — decoupled from generation/storage order. The backend stores
// sections in the order item 1's parser needs (product_feed before next_steps,
// so supporting_finding_ids resolution can see it); this is the order humans
// should see them rendered in.

export const SECTION_DISPLAY_ORDER = [
  "account_overview",
  "what_is_working",
  "worked_before_missing_now",
  "active_but_not_working",
  "structural_gaps",
  "new_campaign_opportunities",
  "product_feed",
  "next_steps",
];

// Unknown keys sort last, after every known key, in their original relative order.
export function sortSectionsForDisplay(sections) {
  const rank = (s) => {
    const i = SECTION_DISPLAY_ORDER.indexOf(s.key);
    return i === -1 ? SECTION_DISPLAY_ORDER.length : i;
  };
  return [...sections]
    .map((s, i) => ({ s, i }))
    .sort((a, b) => rank(a.s) - rank(b.s) || a.i - b.i)
    .map(({ s }) => s);
}
